export default function EntryTableColumn(props) {
    return <td>{props.label}</td>;
}